import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

function scrollWindowToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
}

export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation()

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '')
      // Wait a tick so the target exists after route paint
      const timer = window.setTimeout(() => {
        const target = document.getElementById(id)
        if (target) {
          target.scrollIntoView({ behavior: 'auto', block: 'start' })
        } else {
          scrollWindowToTop()
        }
      }, 0)
      return () => window.clearTimeout(timer)
    }

    scrollWindowToTop()
    // Second pass after layout/images (homepage sections)
    const raf = window.requestAnimationFrame(() => scrollWindowToTop())
    const timer = window.setTimeout(scrollWindowToTop, 50)
    return () => {
      window.cancelAnimationFrame(raf)
      window.clearTimeout(timer)
    }
  }, [pathname, hash, key])

  return null
}
